import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import ApplicationBasicInfoComponent from './application-basic-info.component';
import ApplicationRegConfigurationComponent from './applicationRegConfigurations.component';
import { AppRegFunctionComponent } from './application-function-info.component';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';
import ApplicationConfigurationInfoComponent from './application-configuration-info.component';
import ApplicationMenuMappingComponent from './application-menu-mapping.component';


export const ApplicationRegistrationComponent = ({domainDetails,networks,handleFormMenuMappingItemChange, deleteMenuMappingItems,channels, menuMapping, applicationRegistreation, sellerOnRecords, openConfirmationSeller, onFormSellerItemChange, deleteselectedSellerOnRecord, onFormNetworkChange, networkParticipants, getIsnetworkRecordDeletable, deleteSelectedNetwork, onFormItemChange, deleteSelectedProduct, changeImage, mediaFiles, deleteItems, getIsRecordDeletable, handleClose, handleOpen, openConfirmation, handleFormFunctionItemChange, functionItems, domainFunctions, domains, onFormCancel, onFormChange, tenants, onFormSubmit, selectedApplicationRegistreation}: any) => {
  const libraryData = useSelector(selectListItems)
  const tabItems=[
    {
        id:1,
        title:'Application Details',
        component:<ApplicationBasicInfoComponent 
        onFormChange={onFormChange}
        channels={channels}
        tenants={tenants}
        selectedApplicationRegistreation={selectedApplicationRegistreation}
        networks={networks}
        domainDetails={domainDetails}
        />,
    isVisible:true,
    },
//     {
//       id:2,
//       title:'Application Registration',
//       component:<ApplicationRegConfigurationComponent
//       applicationRegistreation={applicationRegistreation}
//       deleteSelectedNetwork={deleteSelectedNetwork}
//       deleteselectedSellerOnRecord={deleteselectedSellerOnRecord}
//       getIsnetworkRecordDeletable={getIsnetworkRecordDeletable}
//       networkParticipants={networkParticipants}
//       onFormChange={onFormChange}
//       onFormNetworkChange={onFormNetworkChange}
//       onFormSellerItemChange={onFormSellerItemChange}
//       selectedApplicationRegistreation={selectedApplicationRegistreation}
//       sellerOnRecords={sellerOnRecords}
//   />,
//   isVisible:true,
//   },
//   {
//     id:3,
//     title:'Features and Function Mapping',
//     component:<AppRegFunctionComponent
//     deleteItems={deleteItems}
//     domainFunctions={domainFunctions}
//     domains={domains}
//     handleFormFunctionItemChange={handleFormFunctionItemChange}
//     functionItems={functionItems}
// />,
// isVisible:true,
// },
// {
//   id:4,
//   title:'Menu Mapping',
//   component:<ApplicationMenuMappingComponent 
//   menuMapping={menuMapping}
//   deleteMenuMappingItems={deleteMenuMappingItems}
//   handleFormMenuMappingItemChange={handleFormMenuMappingItemChange}
//   domains={domains}
//   />,
// isVisible:true,
// },

// {
//   id:5,
//   title:'Configuration',
//   component:<ApplicationConfigurationInfoComponent 
//   selectedApplicationRegistreation={selectedApplicationRegistreation}
//   onFormChange={onFormChange}
//   />,
// isVisible:true,
// },

{
  id:2,
  title:'Media Mapping',
  component:<MediaInfoComponent
  changeImage={changeImage}
  fileTypes={libraryData?.result?.FileType}
  onFormItemChange={onFormItemChange}
  mediaFiles={mediaFiles}
  />,
isVisible:true,
},
  
  
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={onFormCancel}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={onFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default ApplicationRegistrationComponent;
